<template>
	<div>
		<modal v-if="showModal" @close="showModal = false">
			<template slot="body">
				<md-toolbar :md-elevation="1" class="md-accent">
					<span class="md-display-1">Detalhes</span>
				</md-toolbar>

				<md-list class="md-double-line">
					<md-subheader>Usuário</md-subheader>

					<md-list-item>
					<md-icon class="md-primary">person</md-icon>

					<div class="md-list-item-text">
						<span>{{entity.user.name}}</span>
						<span v-if="entity.user.company">{{entity.user.company.name}}</span>
						<span v-else>Sem empresa</span>
					</div>
					</md-list-item>

					<md-list-item>
					<md-icon class="md-primary">email</md-icon>

					<div class="md-list-item-text">
						<span>{{entity.user.email}}</span>
					</div>
					</md-list-item>

					<md-divider></md-divider>

					<md-list-item>
						<md-icon class="md-primary">pages</md-icon>
						<div class="md-list-item-text">
							<span>{{entity.article.name}}</span>
							<span>Página</span>
						</div>
					</md-list-item>

					<md-card>
						<md-card-header>
							<span class="md-display-1">Avaliação</span>
						</md-card-header>

						<md-card-content>
							<md-subheader>
								Resultado:
								<div style="position: relative; left: 20px;"> {{entity.resultScore}} pontos.</div>
							</md-subheader>
							{{entity.result.text}}
						</md-card-content>
					</md-card>
				</md-list>
			</template>
			<template slot="footer">
				<md-button class="md-danger" @click="showModal = false">Fechar</md-button>
			</template>
		</modal>

		<paginated-search v-bind="{ schema, loadingData, searchEntities, openEntity, exportEntity, autoEnable: true }" ></paginated-search>
	</div>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import ExpressoAux from "@/components/Espresso/EspressoAux.vue";
	import TestResult from "@/models/testResult.model.vue";
	import { Modal } from '@/components';
	import XLSX from 'xlsx';

	export default {
		components: {
			PaginatedSearch,
			Modal,
		},
		data () {
			return {
				pageLoaded: false,
				showModal: false,
				dateMask: "##/##/####",
				companies: [],
				articles: [],
				schema: TestResult.getSchema(),
				loadingData: TestResult.loadingData,
			};
		},
		methods: {
			openEntity(entity) {
				this.entity = entity;

				const parameters = {
					articleId: entity.articleId,
					minimumScore: entity.resultScore,
				};

				TestResult.getTestResult(parameters).then(result => {					
					if (result) {
						this.entity.result = result;
						this.showModal = true;
					} else {
						this.entity.result = {
							text: "Texto de avaliação ainda não cadastrado pelo administrador.",
						}
						this.showModal = true;
					}
				});
			},
			searchEntities(paginationParameters) {
				console.log('pesquisar', paginationParameters);
			
				return TestResult.search(paginationParameters);
			},
			exportEntity(parameters) {
				if((parameters.user === "%undefined%"))
					delete parameters["user"]
				this.$validator.validateAll().then(async (result) => {
					if (result) {
						TestResult.download(parameters)
							.then((response) => {
								const exportWS = XLSX.utils.json_to_sheet(response);
								const wb = XLSX.utils.book_new();

								XLSX.utils.book_append_sheet(wb, exportWS, 'export');

								// export Excel file
								XLSX.writeFile(wb, 'respostas.xlsx');
							})
							.catch((error) => {
								console.log("export error", error);
								ExpressoAux.showWarningModal("Não foi possível encontrar registros.");
							});
					} else {
						ExpressoAux.showFailModal("Preencha os campos de data.");
					}
				});
			},
		},
		created() {

		}
	}
</script>
